import React from 'react';
import { Navigate } from 'react-router-dom';
import { getTokenRole } from '../utils/jwt';

const AdminPrivateRoute = ({ children }) => {
	const token = localStorage.getItem('adminAccessToken');
	const role = getTokenRole(token);
	if (!token || role !== 'ADMIN') {
		return <Navigate to="/admin-login" replace />;
	}
	return children;
};

export default AdminPrivateRoute;
